import { AdminService } from './../../../services/admin.service';
import { PortfolioNavigationComponent } from './../../../partials/navigation/portfolio-navigation/portfolio-navigation.component';
import { UserNavigationComponent } from './../../../partials/navigation/user-navigation/user-navigation.component';
import { UserService } from 'src/app/services/user.service';
import { SeriesService } from './../../../services/series.service';
import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { MinuteSecondsPipe } from 'src/app/helpers/pipes/minuteSeconds.pipe';
import { tap, concatMap, map } from 'rxjs/operators';
import * as jquery from 'jquery';
import { StateChange } from 'ng-lazyload-image';
import * as AOS from 'aos';
import * as NTW from 'number-to-words';
import { AuthService } from 'src/app/services/auth.service';
import { Role } from 'src/app/models';
import {SwiperOptions} from "swiper";
//import { NgImageSliderComponent } from 'ng-image-slider';


declare var require: any;

@Component({
  selector: 'user-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
  providers: [ MinuteSecondsPipe ],
})
export class DashboardComponent implements OnInit, AfterViewInit {

  @ViewChild(UserNavigationComponent) userNavigation;
  @ViewChild(PortfolioNavigationComponent) portfolioNavigation;
  //@ViewChild('nav') slider: NgImageSliderComponent;

  series: any[];
  user: any;
  error = false;
  preloaderImage = require('../../../../assets/images/loader-big.svg');
  modalText = 'Loading...';
  nonAdminRoles = [Role.Individual, Role.Manager, Role.Employee];
  imageObject: any [];

  config: SwiperOptions = {
    initialSlide: 0, // Slide Index Starting from 0
    slidesPerView: 'auto', // Slides Visible in Single View Default is 1
    pagination: { el: '.swiper-pagination', clickable: true },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    },
    spaceBetween: 30
  };

  constructor(
    private route: ActivatedRoute,
    private pageTitleService: Title,
    private seriesService: SeriesService,
    private toMinute: MinuteSecondsPipe,
    private userService: UserService,
    private adminService: AdminService,
    private authService: AuthService,
  ) { }

  ngOnInit(): void {
    this.setPageTitle();

    const currentRole = this.authService.currentUserValue.role;
    if (currentRole && this.nonAdminRoles.indexOf(currentRole) >= 0) {
      this.loadData();
    } else {
      this.authService.getTokenDetails(this.authService.tokenValue)
        .subscribe(response => {
          if (response && response.data.role === Role.Admin) {
            this.loadAdminData();
          } else {
            this.loadData();
          }
        });
    }

    AOS.init();
    this.loadScroll();
    this.resize_parallax();
  }

  ngAfterViewInit(): void {
    //jquery(".custom-image-main img").css("border-radius", "50% !important");
  }

  resize_parallax() {
    jquery(window).on('resize', () => {
      const divId = 'parallax_img';
      const pct = 10;
      const div = jquery('#' + divId);
      const divwidth = div.width();
      let newheight: any = Math.round(divwidth * (pct / 100));
      newheight = newheight + 'px';
      div.height(newheight);
    });
  }

  loadScroll() {
    jquery(window).scroll(function() {
      if (jquery(this).scrollTop() > 100) {
        jquery('.back-to-top').fadeIn('slow');
      } else {
        jquery('.back-to-top').fadeOut('slow');
      }
    });
  }

  setPageTitle() {
    this.pageTitleService.setTitle(this.route.snapshot.data.title || 'Dashboard');
  }

  loadData() {

    // Show progress modal
    this.showProgressModal();

    this.userService.getProfile()
      .pipe(

        // Get User Details
        map(user => user.data.user),
        tap(user => this.portfolioNavigation.user = user),

        // Get Series
        concatMap(() => this.seriesService.getSeries()),
        map(series => series.data.series),
        tap(series => {
          let moduleCount = 0;
          this.series = series;
          this.series.map(seriesData => {
            let words = NTW.toWords(seriesData.sequence_number + 1);
            words = words.charAt(0).toUpperCase() + words.slice(1);
            return seriesData.sequence_number = words;
          });
          this.series.forEach(moduleData => {
            return moduleData.modules.forEach(module => {
              // Formats video duration
              module.video_duration = this.toMinute.transform(module.video_duration);

              // Sets module total available points
              let totalAvailablePoints = 10;

              if (module.quiz == 1) {
                totalAvailablePoints += 5;
              }

              if (module.summary == 1) {
                totalAvailablePoints += 5;
              }

              module.totalAvailablePoints = totalAvailablePoints;

              // Sets the module count
              moduleCount += 1;
              module.moduleNo = moduleCount;
            });
          });
        }),

        // Get User Statistics
        concatMap(() => this.userService.getUserStatistics()),
        map(stats => stats.data.tasks_completed),
        tap(stats => {
          const completedModules = stats.by_modules;

          if (completedModules.length > 0) {
              this.series.forEach(seriesData => {
                return seriesData.modules.forEach(module => {
                  completedModules.forEach(cSeries => {
                    cSeries.modules.forEach(cModule => {

                      // Get Video Completion Status
                      if (cSeries.series_id == seriesData.series_id && cModule.module_id == module.id &&
                        cModule.hasOwnProperty('video')) {
                        module.video_completed = true;
                      }

                      // Get Quiz Completion Status
                      if (cSeries.series_id == seriesData.series_id && cModule.module_id == module.id &&
                        cModule.hasOwnProperty('quiz')) {
                        module.quiz_completed = true;
                      }

                      // Get Exercise Completion Status
                      if (cSeries.series_id == seriesData.series_id && cModule.module_id == module.id &&
                        cModule.hasOwnProperty('exercise')) {
                        module.exercise_completed = true;
                      }

                      // Get Summary Completion Status
                      if (cSeries.series_id == seriesData.series_id && cModule.module_id == module.id &&
                        cModule.hasOwnProperty('summary')) {
                        module.summary_completed = true;
                      }

                      // Get Module Points
                      if (cSeries.series_id == seriesData.series_id && cModule.module_id == module.id &&
                        cModule.hasOwnProperty('module_points')) {
                        module.points = cModule.module_points;
                      }
                    });
                  });
                });
              });
          }

        })
      )
      .subscribe(
        response => {

          // display the progress tracker slider
          this.displayProgressTracker();

          if (response) {
            // hide progress modal
            this.hideProgressModal();

            // Sets the module description box dynamically based on the highest div height
            this.setBoxMaximumHeight();
          }
        },
        error => {
          // hide progress modal
          this.hideProgressModal();
          this.error = true;
        }
      );
  }

  loadAdminData() {

    // Show progress modal
    this.showProgressModal();

    this.adminService.getProfile()
      .pipe(

        // Get User Details
        map(user => user.data.user),
        tap(user => this.portfolioNavigation.user = user),

        // Get Series
        concatMap(() => this.seriesService.getSeriesAdminDashboard()),
        map(series => series.data.series),
        tap(series => {
          let moduleCount = 0;
          this.series = series;
          this.series.map(seriesData => {
            let words = NTW.toWords(seriesData.sequence_number + 1);
            words = words.charAt(0).toUpperCase() + words.slice(1);
            return seriesData.sequence_number = words;
          });
          this.series.forEach(moduleData => {
            return moduleData.modules.forEach(module => {

              // Formats video duration
              module.video_duration = this.toMinute.transform(module.video_duration);

              // Sets module total available points
              let totalAvailablePoints = 10;

              if (module.quiz == 1) {
                totalAvailablePoints += 5;
              }

              if (module.summary == 1) {
                totalAvailablePoints += 5;
              }

              module.totalAvailablePoints = totalAvailablePoints;

              // Sets the module count
              moduleCount += 1;
              module.moduleNo = moduleCount;

            });
          });
        }),

        // Get User Statistics
        concatMap(() => this.adminService.getUserStatistics()),
        map(stats => stats.data.tasks_completed),
        tap(stats => {
          const completedModules = stats.by_modules;

          if (completedModules.length > 0) {
              this.series.forEach(seriesData => {
                return seriesData.modules.forEach(module => {
                  completedModules.forEach(cSeries => {
                    cSeries.modules.forEach(cModule => {

                      // Get Video Completion Status
                      if (cSeries.series_id == seriesData.series_id && cModule.module_id == module.id &&
                        cModule.hasOwnProperty('video')) {
                        module.video_completed = true;
                      }

                      // Get Quiz Completion Status
                      if (cSeries.series_id == seriesData.series_id && cModule.module_id == module.id &&
                        cModule.hasOwnProperty('quiz')) {
                        module.quiz_completed = true;
                      }

                      // Get Exercise Completion Status
                      if (cSeries.series_id == seriesData.series_id && cModule.module_id == module.id &&
                        cModule.hasOwnProperty('exercise')) {
                        module.exercise_completed = true;
                      }

                      // Get Summary Completion Status
                      if (cSeries.series_id == seriesData.series_id && cModule.module_id == module.id &&
                        cModule.hasOwnProperty('summary')) {
                        module.summary_completed = true;
                      }

                      // Get Module Points
                      if (cSeries.series_id == seriesData.series_id && cModule.module_id == module.id &&
                        cModule.hasOwnProperty('module_points')) {
                        module.points = cModule.module_points;
                      }
                    });
                  });
                });
              });
          }

        })
      )
      .subscribe(
        response => {

          // display the progress tracker slider
          this.displayProgressTracker();

          if (response) {
            // hide progress modal
            this.hideProgressModal();

            // Sets the module description box dynamically based on the highest div height
            this.setBoxMaximumHeight();
          }
        },
        error => {
          // hide progress modal
          this.hideProgressModal();
          this.error = true;
        }
      );
  }

  displayProgressTracker() {

    this.imageObject = [];

    this.series.forEach(moduleData => {
      let seriesId = moduleData.series_id;
      return moduleData.modules.forEach(module => {
        // Sets module total available points
        let totalAvailablePoints = 10;

        if (module.quiz == 1) {
          totalAvailablePoints += 5;
        }

        if (module.summary == 1) {
          totalAvailablePoints += 5;
        }

        module.totalAvailablePoints = totalAvailablePoints;

        //add image module list
        let modulePoints = 0;
        if (module.points) {
          modulePoints = module.points;
        }

        let objImage = { id: module.id,
                         image: module.cover_url,
                         module: module.moduleNo,
                         points: modulePoints,
                         total: totalAvailablePoints,
                         seriesId: seriesId };

        this.imageObject.push(objImage);
      })
    });

  }

  private setBoxMaximumHeight() {
    let maxHeight = 0;
    jquery('.module-info').each(function() {
        if (jquery(this).height() > maxHeight) {
          maxHeight = jquery(this).height();
        }
    });
    jquery('.module-info').height(maxHeight);
  }

  moduleImageCallback(event: StateChange, seriesId: number, moduleId: number) {
    switch (event.reason) {
      case 'setup':
        // The lib has been instantiated but we have not done anything yet.
        const imageContainerOnInit: HTMLElement = document.getElementById('module_image_' + seriesId + '_' + moduleId);
        imageContainerOnInit?.classList.add('module-image-loading');
        break;
      case 'observer-emit':
        // The image observer (intersection/scroll observer) has emit a value so we
        // should check if the image is in the viewport.
        // `event.data` is the event in this case.
        break;
      case 'start-loading':
        // The image is in the viewport so the image will start loading
        break;
      case 'mount-image':
        // The image has been loaded successfully so lets put it into the DOM
        break;
      case 'loading-succeeded':
        // The image has successfully been loaded and placed into the DOM
        const imageContainerAfterInit: HTMLElement = document.getElementById('module_image_' + seriesId + '_' + moduleId);
        imageContainerAfterInit?.classList.remove('module-image-loading');
        imageContainerAfterInit?.classList.add('module-image-fit');

        // Module Points
        const moduleBadgePointsContainer: HTMLElement = document.getElementById('module_badge_points_' + seriesId + '_' + moduleId);
        moduleBadgePointsContainer?.classList.remove('d-none');
        moduleBadgePointsContainer?.classList.add('d-flex');

        // Module Video Status
        const moduleBadgeVideoContainer: HTMLElement = document.getElementById('module_badge_video_' + seriesId + '_' + moduleId);
        moduleBadgeVideoContainer?.classList.remove('d-none');
        moduleBadgeVideoContainer?.classList.add('d-flex');

        // Module Video Duration
        const moduleBadgeVideoDurationContainer: HTMLElement = document.getElementById('module_badge_video_duration_' + seriesId + '_' + moduleId);
        moduleBadgeVideoDurationContainer?.classList.remove('d-none');
        moduleBadgeVideoDurationContainer?.classList.add('d-flex');

        // Module Play Button
        const playButtonContainer: HTMLElement = document.getElementById('module_play_' + seriesId + '_' + moduleId);
        playButtonContainer?.classList.add('badge-play');

        break;
      case 'loading-failed':
        // The image could not be loaded for some reason.
        // `event.data` is the error in this case
        break;
      case 'finally':
        // The last event before cleaning up
        break;
    }
  }

  private showProgressModal() {
    jquery('#loaderSpin').show();
  }

  private hideProgressModal() {
    jquery('#loaderSpin').hide();
  }


}
